export default __webpack_public_path__ + "static/media/facebook-round.40dc2a2f.svg";